// Asserts this call is unreachable
// Used to make exhaustive switch
export function assertUnreachable(_: never): never {
  throw new Error("Didn't expect to get here")
}
